import { useState } from 'react';
import { Alert, AlertTitle, Stack, Typography } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { useSnackbar } from 'notistack';
import { useConfirm } from 'material-ui-confirm';
import server from '../../../global/server';

const formatar = data =>
    data ? new Date(data).toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' }) : '—';

/**
 * Aviso de que o anfitriao trocou o horario deste encontro.
 *
 * O conviva nao escolheu essa mudanca, entao ele pode sair sem prejuizo: no
 * encontro pago o valor volta integral, e no gratuito o cancelamento e liberado
 * mesmo faltando menos de 24h. Quem decide isso e o servidor - aqui so
 * apresentamos a saida.
 */
export default ({ orderId, anterior, atual, gratuito, onCancelado }) => {
    const { enqueueSnackbar } = useSnackbar();
    const confirm = useConfirm();
    const [cancelando, setCancelando] = useState(false);

    const cancelar = async () => {
        try {
            await confirm({
                title: gratuito ? 'Cancelar sua vaga?' : 'Cancelar e receber o reembolso?',
                description: gratuito
                    ? 'Você perderá a sua vaga neste encontro. Esta ação é irreversível.'
                    : 'Sua vaga será cancelada e o valor pago será devolvido integralmente. Esta ação é irreversível.',
                confirmationText: 'Confirmar',
                cancellationText: 'Voltar',
            });
        } catch {
            return;
        }

        try {
            setCancelando(true);
            const { data } = await server.delete('/booking/cancel', { data: { order_id: orderId } });
            enqueueSnackbar(data?.message || 'Encontro cancelado', { variant: 'success' });
            onCancelado?.();
        } catch (error) {
            enqueueSnackbar(error.response?.data?.message || 'Erro ao cancelar', { variant: 'error' });
        } finally {
            setCancelando(false);
        }
    };

    return (
        <Alert severity="warning" sx={{ width: '100%', borderRadius: '12px' }}>
            <AlertTitle sx={{ fontWeight: 600 }}>O anfitrião alterou o horário</AlertTitle>

            <Stack spacing={0.5} sx={{ mb: 1.5 }}>
                <Typography variant="body2">
                    Antes: <s>{formatar(anterior)}</s>
                </Typography>
                <Typography variant="body2" fontWeight={600}>
                    Agora: {formatar(atual)}
                </Typography>
            </Stack>

            <Typography variant="body2" sx={{ mb: 1.5 }}>
                {gratuito
                    ? 'Se o novo horário não funcionar para você, pode cancelar sua vaga a qualquer momento.'
                    : 'Se o novo horário não funcionar para você, pode cancelar e receber o valor pago de volta, integralmente.'}
            </Typography>

            <LoadingButton
                onClick={cancelar}
                loading={cancelando}
                variant="outlined"
                color="warning"
                size="small"
                sx={{ textTransform: 'none' }}
            >
                {gratuito ? 'Cancelar minha vaga' : 'Cancelar e ser reembolsado'}
            </LoadingButton>
        </Alert>
    );
};
